import { render, staticRenderFns } from "./BankGroupList.vue?vue&type=template&id=0f2ae3b4&"
import script from "./BankGroupList.vue?vue&type=script&lang=js&"
export * from "./BankGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports